export const IL_UPDATE_ZIP = 'income-limits/UPDATE_ZIP';
export const IL_UPDATE_DEPENDENTS = 'income-limits/UPDATE_DEPENDENTS';
export const IL_UPDATE_YEAR = 'income-limits/UPDATE_YEAR';
export const IL_EDIT_MODE = 'income-limits/EDIT_MODE';
export const IL_PAST_MODE = 'income-limits/PAST_MODE';
export const IL_UPDATE_RESULTS = 'income-limits/UPDATE_RESULTS';
export const IL_ZIP_VAL_ERROR = 'income-limits/ZIP_VAL_ERROR';
export const IL_RESULTS_VAL_ERROR = 'income-limits/RESULTS_VAL_ERROR';
export const IL_RESULTS_VAL_ERROR_TEXT = 'income-limits/RESULTS_VAL_ERROR_TEXT';

export const ROUTES = {
  DEPENDENTS: 'dependents',
  HOME: 'introduction',
  REVIEW: 'review',
  RESULTS: 'results',
  YEAR: 'year',
  ZIPCODE: 'zip',
};
